import React from "react";

import HeroSection from "./components/HeroSection/HeroSection";

import constructionImg from "../../assets/images/industries-constructions.jpg";
import educationImg from "../../assets/images/industries-education.jpg";
import automotiveImg from "../../assets/images/industries-automotive.jpg";
import healthcareImg from "../../assets/images/industries-healthcare.jpg";
import ecommerceImg from "../../assets/images/industries-ecommerce.jpg";
import hospitalityImg from "../../assets/images/industries-hospitality.jpg";
import manufacturingImg from "../../assets/images/industries-manufacturing.jpg";
import energyImg from "../../assets/images/industries-energy.jpg";
import logisticsImg from "../../assets/images/industries-logistics.jpg";
import bfsiImg from "../../assets/images/industries-bfsi.jpg";

const Card = ({ image, heading, description }) => (
  <div className="bg-white shadow-md rounded-lg overflow-hidden w-60">
    <img src={image} alt={heading} className="w-full h-48 object-cover" />
    <div className="p-4">
      <h2 className="text-xl font-bold mb-2 text-teal-600">{heading}</h2>
      <p className="text-gray-700">{description}</p>
    </div>
  </div>
);

const IndustriesPage = () => {
  const cardsData = [
    {
      image: constructionImg,
      heading: "Construction and Real Estate",
      description:
        "Provide 24/7 support to clients and automate lead capture, scheduling, and site visit. Personalized follow-ups and instant insights keep projects on track and help close deals faster.",
    },
    {
      image: educationImg,
      heading: "Education",
      description:
        "Streamline admissions, automate query support for better conversions & faster lead capture with AI chatbot for education. Deliver round-the-clock multilingual assistance for students and staff, while automating task tracking and billing.",
    },
    {
      image: automotiveImg,
      heading: "Automotive",
      description:
        "Enable 24/7 customer support and engagement, automate lead qualification, supply chain tracking, and provide predictive maintenance alerts. Keep production moving while delivering personalized customer interactions.",
    },
    {
      image: healthcareImg,
      heading: "Healthcare",
      description:
        "Enhance patient care with 24/7 assistance, personalized recommendations, fast data entry, and behavior analytics. AI improves response times, supporting healthcare staff and patients alike.",
    },
    {
      image: ecommerceImg,
      heading: "E-commerce",
      description:
        "Offer customers 24/7 support and personalized shopping experiences, from targeted lead generation to post-purchase follow-ups. AI keeps engagement high and stock levels optimized in real-time.",
    },
    {
      image: hospitalityImg,
      heading: "Hospitality",
      description:
        "Enhance guest experiences with automated booking, 24/7 support, and personalized recommendations. Streamlined invoicing and real-time updates create lasting guest satisfaction.",
    },
    {
      image: manufacturingImg,
      heading: "Manufacturing",
      description:
        "Optimize, Automate, Succeed with AI Chatbots in Manufacturing. Optimize production with predictive monitoring, automated reporting, and real-time supply chain insights.",
    },
    {
      image: energyImg,
      heading: "Energy (Oil, Gas, and Renewables)",
      description:
        "Boost safety with instant alerts, optimize resources with data-driven insights, and ensure equipment reliability. 24/7 support offers best experience and personalized alerts for efficient operations.",
    },
    {
      image: logisticsImg,
      heading: "Logistics and Supply Chain",
      description:
        "Maintain 24/7 visibility across deliveries, enhance communication, and streamline task management. AI-driven insights provide personalized customer updates and efficient tracking from start to finish.",
    },
    {
      image: bfsiImg,
      heading: "BFSI (Banking, Financial Services, and Insurance)",
      description:
        "Deliver 24/7 customer assistance, payment integration, personalized client engagement, and fast query resolution. Smart insights into risk management help build customer trust while driving secure growth.",
    },
  ];

  return (
    <div>
      <HeroSection />
      <div className="text-4xl bg-blue-400 font-bold text-white text-center p-8 my-4">
        Industries We Serve
      </div>
      <div className="container mx-auto px-4 py-8 flex flex-wrap gap-6 justify-center">
        {cardsData.map((card, index) => (
          <Card
            key={index}
            image={card.image}
            heading={card.heading}
            description={card.description}
          />
        ))}
      </div>
    </div>
  );
};

export default IndustriesPage;
